// Keep the calculator's included-seat tier selection; charge for any overflow.
export function stackComparisonCost(pricing, teamSize, stackMonthly) {
  const plan = pricing.plans.find((plan) => plan.seats >= teamSize) || pricing.plans.at(-1);
  const extraSeats = Math.max(0, teamSize - plan.seats);
  const additionalSeats = pricing.categories.flatMap((category) => category.rows)
    .find((row) => row.key === 'additionalSeats');
  const extraSeatRate = extraSeats > 0
    ? Number(additionalSeats.cells[pricing.plans.indexOf(plan)].replace(/^\$/, ''))
    : 0;
  const monthly = Number(plan.monthly) + extraSeats * extraSeatRate;

  return { plan, extraSeats, extraSeatRate, monthly, monthlyDelta: stackMonthly - monthly };
}
